<div class="d-flex justify-content-start align-items-center">
    <h6> Scegliere il nuovo C/C:</h6>
</div>
<app-basic-form [form]="form" [keys]="formKeys"></app-basic-form>
<div class="d-flex flex-column justify-content-start mt-4">
    <div class="card-disclaimer-label" *ngIf="showErrorMessage">Attenzione! Le uniche coordinate bancarie disponibili per la selezione coincidono con quelle correnti</div>
</div>

